import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
  ReactNode,
} from "react";
import { SingleUserDTO } from "../types/userDTOs";

export const EmptyUser: SingleUserDTO = {
  id: 0,
  username: "",
  email: "",
  phoneNumber: null,
  enabled: false,
  role: "",
  profilePhoto: null,
  following: 0,
  followers: [],
  instagramPost: 0,
  address: null,
  artistInfo: null,
  likedPost: 0,
  artistRequestPending: false,
};

export interface UserContextInterface {
  user: SingleUserDTO;
  setUser: Dispatch<SetStateAction<SingleUserDTO>>;
}

const defaultState = {
  user: EmptyUser,
  setUser: (user: SingleUserDTO) => {},
};

export const UserContext = createContext(defaultState);

type UserProviderProps = {
  children: ReactNode;
};

export default function UserProvider({ children }: UserProviderProps) {
  const [user, setUser] = useState<SingleUserDTO>(EmptyUser);
  const value = useMemo(() => ({ user, setUser }), [user]);
  return (
    <UserContext.Provider value={value}>{children}</UserContext.Provider>
  );
}

/** Convenience hook for consuming the user context. */
export const useUser = () => useContext(UserContext);
